import AddIcon from "@mui/icons-material/Add";
import { Alert, Box, Grid, Snackbar, Typography } from "@mui/material";
import CustomButton from "components/CustomButton";
import PaginationComponent from "components/Pagination";
import { useGetUsers } from "hooks/queries/useGetUsers";
import { useSnackbar } from "hooks/useSnackbar";
import { useContext, useState } from "react";
import AddEmployeeForm from "./AddEmployeeForm";
import EmployeeCard from "./EmployeeCard";
import { IUser } from "models/Employee";
import { specialNames } from "constants/specialNames";
import { findPermission } from "utilities/findPermission";
import { AuthContext } from "navigation/AuthProvider";

const AllEmployees = () => {
  const [employeeFormOpen, setEmployeeFormOpen] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<IUser | null>(null);
  const { getSnackbarProps } = useSnackbar();
  const { user } = useContext(AuthContext);

  const { users, paginationData, isLoading } = useGetUsers();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const totalPages = paginationData?.last_page || 1;

  const handleOpenEmployeeAddForm = () => {
    setEmployeeFormOpen(true);
  };

  const handleCloseEmployeeAddForm = () => {
    setEmployeeFormOpen(false);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const perPage = paginationData?.per_page || 1;
  const startIndex = (currentPage - 1) * perPage;
  const endIndex = startIndex + perPage;
  const paginatedData = users?.slice(startIndex, endIndex);

  const canCreateUsers = [specialNames.ADMIN];
  const canCreateUsersPermission = findPermission(canCreateUsers, user.user.roles[0].name);

  return (
    <>
      <Box display="flex" flexDirection="column">
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" sx={{ fontSize: "30px", fontWeight: 800 }}>
            <span style={{ color: "#1976d2" }}>{users?.length}</span> Employees
          </Typography>
          <CustomButton
            startIcon={<AddIcon />}
            title="Add Employee"
            sx={{
              alignSelf: "start",
              // "&.Mui-disabled": { background: "#146ED2", opacity: 10, color: "white" },
            }}
            disabled={!canCreateUsersPermission}
            onClick={handleOpenEmployeeAddForm}
          />
        </Box>
        <Box sx={{ mt: 1 }} maxWidth="1350px" margin="auto">
          <Grid container spacing={3}>
            {isLoading ? (
              <div className="loader">
                <div className="justify-content-center jimu-primary-loading"></div>
              </div>
            ) : (
              <>
                {paginatedData.map((employee, key) => (
                  <Grid item key={key} xs={12} md={6} lg={3}>
                    <EmployeeCard
                      employees={employee}
                      selectedUser={selectedUser}
                      setSelectedUser={setSelectedUser}
                    />
                  </Grid>
                ))}
              </>
            )}
          </Grid>
        </Box>
        <PaginationComponent
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
        <AddEmployeeForm
          employeeFormOpen={employeeFormOpen}
          handleCloseEmployeeAddForm={handleCloseEmployeeAddForm}
        />
      </Box>
      <Snackbar
        {...getSnackbarProps()}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={4000}
      >
        <Alert {...getSnackbarProps()}>{getSnackbarProps().message}</Alert>
      </Snackbar>
    </>
  );
};

export default AllEmployees;
